<template>
    <div style="height: 100%">
        <div v-if="questionWentiDialog" class="flex_center" style="height: 100%;background-color: #fff">
            <div class="newHuokequestion  flex_item_satrt" style="height: 100%;">
                <div class="" style="height: 100%;width:71.8%;position: relative;">
                    <div class="leads-content">
                        <div class="leads-flex">

                            <div class="leads-content-right" style="min-height: 45rem;">
                                <div class="leads-content-right-content" >
                                    <ul class="newHouke-ul margin-top20 margin-bottom30">
                                        <li class="newHouke-li" v-for="(item, index) in 4"
                                            :class="NewShowIndex >= index ? 'newShowActive' : ''" :key="index"
                                            @click="ActiceNewIndex(index)"></li>
                                    </ul>
                                    <div>
                                        <div v-for="(item, index) in QuestionPageList" :key="index">
                                            <div class="question-step-con"
                                                v-if="item.leadsQuestions?.pageNo == 1 && NewShowIndex == 0">
                                                <p class="question-step-question margin-bottom30">
                                                    <span class="bitian"
                                                        v-if="item.leadsQuestions?.required == 1">*</span>{{
                                                            item.leadsQuestions.questionContent }}
                                                </p>

                                                <div v-if="item.leadsQuestions.type == 2 && NewShowIndex == 0">
                                                    <div class="NewHuokeradio">
                                                        <el-radio-group v-model="item.selectedCodes">
                                                            <el-radio v-for="(ite) in item.leadsOptions"
                                                                :key="ite.optionsCode" border
                                                                :class="item.selectedCodes?.optionsCode == ite.optionsCode ? 'ActiveRedio' : ''"
                                                                @change="leadsQuestionschange(ite)"
                                                                :label=ite><span v-html="ite.optionsIcon" class="margin-right20"></span> {{ ite.optionsContent }}</el-radio>

                                                        </el-radio-group>

                                                    </div>
                                                </div>

                                            </div>
                                            <div class="question-step-con"
                                                v-if="item.leadsQuestions?.pageNo == 2 && NewShowIndex == 1">
                                                <p class="question-step-question margin-bottom30">
                                                    <span class="bitian"
                                                        v-if="item.leadsQuestions?.required == 1">*</span>{{
                                                            item.leadsQuestions.questionContent }}
                                                </p>

                                                <div v-if="item.leadsQuestions.type == 2 && NewShowIndex == 1">
                                                    <div class="NewHuokeradio">
                                                        <el-radio-group v-model="item.selectedCodes">
                                                            <el-radio v-for="(ite) in item.leadsOptions"
                                                                :key="ite.optionsCode" border
                                                                :class="item.selectedCodes?.optionsCode == ite.optionsCode ? 'ActiveRedio' : ''"
                                                                @change="leadsQuestionschange(ite)"
                                                                :label=ite> <span v-html="ite.optionsIcon" class="margin-right20"></span> {{ ite.optionsContent }}</el-radio>

                                                        </el-radio-group>

                                                    </div>
                                                </div>

                                            </div>

                                            <div class="question-step-con margin-bottom30"
                                                v-if="item.leadsQuestions?.pageNo == 3 && NewShowIndex == 2">
                                                <p class="question-step-question margin-bottom30">
                                                    <span class="bitian"
                                                        v-if="item.leadsQuestions?.required == 1">*</span>{{
                                                            item.leadsQuestions.questionContent }}

                                                </p>
                                                <div v-if="item.leadsQuestions.type == 2">
                                                    <el-select style="width: 100%" clearable value-key="optionsCode"
                                                        :popper-append-to-body="false" v-model="item.selectedCodes"
                                                        :placeholder="item.leadsQuestions.defaultTips">
                                                        <el-option v-for="(ite) in item.leadsOptions"
                                                            :key="ite.optionsCode" :label="ite.optionsContent"
                                                            :value="ite">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                                <div v-if="item.leadsQuestions.type == 3">
                                                    <el-select style="width: 100%" clearable filterable
                                                        value-key="optionsCode" ref="upSelectduoxuan" :multiple="true"
                                                        :popper-append-to-body="false" v-model="item.selectedCodes"
                                                        :placeholder="item.leadsQuestions.defaultTips">
                                                        <el-option v-for="(ite) in item.leadsOptions"
                                                            :key="ite.optionsCode" :label="ite.optionsContent"
                                                            :value="ite">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                                <div v-if="item.leadsQuestions.type == 8 && item.leadsQuestions.required == 1"
                                                    style="position: relative;">
                                                    <el-select filterable style="width: 100%;" :loading="loading"
                                                        value-key="optionsCode" loading-text="" :no-data-text="''"
                                                        no-match-text="" v-model="item.selectedCodes" remote
                                                        :remote-method="debouncedRemoteMethod"
                                                        @focus="debouncedRemoteMethodfocus"
                                                        :popper-append-to-body="false"
                                                        :placeholder="item.leadsQuestions.defaultTips">
                                                        <el-option v-for="(ite) in item.leadsOptions" :loading="loading"
                                                            :key="ite.id"  :value="ite" :label="ite.optionsContent">
                                                            <el-tooltip :disabled="ite.optionsContent.length < 70"
                                                           
                                                                effect="dark" :content="ite.optionsContent"
                                                                placement="top">
                                                                 <div slot="content" style="max-width: 630px;">{{ite.optionsContent}}</div>
                                                                <span
                                                                    style="display: block;max-width: 630px;line-height: auto;"
                                                                    class="Country_name"
                                                                    v-html="highlightKeyword(ite.optionsContent)"></span>
                                                            </el-tooltip>

                                                        </el-option>
                                                    </el-select>
                                                    <i style="cursor: pointer;"
                                                        class="el-saech-eye el-input__icon el-icon-search"></i>

                                                </div>
                                                <div v-if="item.leadsQuestions.type == 9" style="position: relative;">
                                                    <el-select filterable :loading="loading" style="width: 100%;"
                                                        :popper-append-to-body="false" ref="upSelectduoxuanSearch"
                                                        value-key="aaa_id" v-model="item.selectedCodes" remote
                                                        :multiple="true"
                                                        :remote-method="item.leadsQuestions.code == 6 ? debouncedRemoteMethodCompany : debouncedRemoteMethodCompany3"
                                                        :placeholder="item.leadsQuestions.defaultTips">
                                                        <el-option v-for="(ite) in item.leadsOptions" :key="ite.aaa_id"
                                                            :label="ite.optionsContent" :value="ite">
                                                            <div style="max-width: 630px;"
                                                                class="flex_center_start_box Search_Company"> <img
                                                                    class="Country_img" :src="ite.flag" />
                                                                <el-tooltip :disabled="ite.optionsContent.length < 60"
                                                                    effect="dark" :content="ite.optionsContent"
                                                                    placement="top">
                                                                    <span class="Country_name">{{ ite.optionsContent
                                                                        }}</span>
                                                                </el-tooltip>
                                                            </div>
                                                        </el-option>
                                                    </el-select>
                                                    <i class="el-saech-eye el-input__icon el-icon-search"></i>
                                                </div>

                                            </div>

                                            <div class="question-step-con margin-bottom30"
                                                v-if="item.leadsQuestions?.pageNo == 4 && NewShowIndex == 3 && item.leadsQuestions.required == 1">
                                                <p class="question-step-question margin-bottom30">
                                                    <span class="bitian"
                                                        v-if="item.leadsQuestions?.required == 1">*</span>{{
                                                            item.leadsQuestions.questionContent }}

                                                </p>
                                                <div v-if="item.leadsQuestions.type == 2">
                                                    <el-select style="width: 100%" clearable value-key="optionsCode"
                                                        :popper-append-to-body="false" v-model="item.selectedCodes"
                                                        :placeholder="item.leadsQuestions.defaultTips">
                                                        <el-option v-for="(ite) in item.leadsOptions"
                                                            :key="ite.optionsCode" :label="ite.optionsContent"
                                                            :value="ite">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                                <div v-if="item.leadsQuestions.type == 3">
                                                    <el-select style="width: 100%" clearable filterable
                                                        value-key="optionsCode" ref="upSelectduoxuan" :multiple="true"
                                                        :popper-append-to-body="false" v-model="item.selectedCodes"
                                                        :placeholder="item.leadsQuestions.defaultTips">
                                                        <el-option v-for="(ite) in item.leadsOptions"
                                                            :key="ite.optionsCode" :label="ite.optionsContent"
                                                            :value="ite">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                                <div v-if="item.leadsQuestions.type == 8 && item.leadsQuestions.required == 1"
                                                    style="position: relative;">
                                                    <el-select filterable style="width: 100%;" :loading="loading"
                                                        value-key="aaa_id" loading-text="" :no-data-text="''"
                                                        no-match-text="" v-model="item.selectedCodes" remote
                                                        :remote-method="debouncedRemoteMethod"
                                                        @focus="debouncedRemoteMethodfocus"
                                                        :popper-append-to-body="false"
                                                        :placeholder="item.leadsQuestions.defaultTips">
                                                        <el-option v-for="(ite) in item.leadsOptions" :loading="loading"
                                                            :key="ite.id" :label="ite.optionsContent" :value="ite">
                                                            <el-tooltip :disabled="ite.optionsContent.length < 65"
                                                                effect="dark" :content="ite.optionsContent"
                                                                placement="top">
                                                                <span
                                                                    style="display: block;max-width: 630px;line-height: auto;"
                                                                    class="Country_name"
                                                                    v-html="highlightKeyword(ite.optionsContent)"></span>
                                                            </el-tooltip>

                                                        </el-option>
                                                    </el-select>
                                                    <i style="cursor: pointer;"
                                                        class="el-saech-eye el-input__icon el-icon-search"></i>

                                                </div>
                                                <div v-if="item.leadsQuestions.type == 9" style="position: relative;">
                                                    <el-select filterable :loading="loading" style="width: 100%;"
                                                        :popper-append-to-body="false" ref="upSelectduoxuanSearch"
                                                        value-key="aaa_id" v-model="item.selectedCodes" remote
                                                        :multiple="true"
                                                        :remote-method="item.leadsQuestions.code == 6 ? debouncedRemoteMethodCompany : debouncedRemoteMethodCompany3"
                                                        :placeholder="item.leadsQuestions.defaultTips">

                                                        <el-option v-for="(ite) in item.leadsOptions" :key="ite.aaa_id"
                                                            :label="ite.optionsContent" :value="ite">
                                                            <div style="max-width: 630px;"
                                                                class="flex_center_start_box Search_Company"> <img
                                                                    class="Country_img" :src="ite.flag" />
                                                                <el-tooltip :disabled="ite.optionsContent.length < 60"
                                                                    effect="dark" :content="ite.optionsContent"
                                                                    placement="top">
                                                                    <span class="Country_name">{{ ite.optionsContent
                                                                        }}</span>
                                                                </el-tooltip>
                                                            </div>
                                                        </el-option>
                                                    </el-select>
                                                    <i class="el-saech-eye el-input__icon el-icon-search"></i>
                                                </div>

                                            </div>
                                        </div>


                                        <el-collapse 
                                            v-if="(QuestionPageList.filter(item => item.leadsQuestions?.required == 2)).length > 0 && NewShowIndex == 3"
                                            v-model="activeNames" @change="handleactiveNamesChange">
                                            <el-collapse-item  name="1">
                                                 <template slot="title">
                                                  <span class="el-collapse-hade">
                                                     Optional Questions
                                                  </span>
                                                    </template>
                                                <div v-for="(item, index) in QuestionPageList" :key="index">

                                                    <div class="question-step-con"
                                                        v-if="item.leadsQuestions?.pageNo == 4 && item.leadsQuestions?.required == 2">
                                                        <p class="question-step-question">
                                                            <span class="bitian"
                                                                v-if="item.leadsQuestions?.required == 1">*</span>{{
                                                                    item.leadsQuestions.questionContent }}
                                                        </p>
                                                        <el-input v-if="item.leadsQuestions.type == 7" id="ceb3e3"
                                                            v-model="item.selectedCodes"
                                                            :placeholder="item.leadsQuestions.defaultTips">
                                                        </el-input>
                                                        <div v-if="item.leadsQuestions.id == 11">
                                                            <el-cascader v-model="item.showCode" ref="cascader"
                                                                filterable :popper-append-to-body="false"
                                                                :props="cascaderProps" :options="item.leadsOptions"
                                                                :placeholder="item.leadsQuestions.defaultTips"
                                                                @change="handleChangetwo">
                                                            </el-cascader>
                                                        </div>
                                                        <div
                                                            v-if="item.leadsQuestions.type == 2 && item.leadsQuestions.id != 11">
                                                            <el-select style="width: 100%" ref="upSelectwo"
                                                                value-key="optionsCode" filterable
                                                                v-model="item.selectedCodes"
                                                                :placeholder="item.leadsQuestions.defaultTips">
                                                                <el-option v-for="(ite) in item.leadsOptions"
                                                                    :key="ite.optionsCode" :label="ite.optionsContent"
                                                                    :value="ite">
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                        <div v-if="item.leadsQuestions.type == 3">
                                                            <el-select style="width: 100%;" clearable 
                                                                value-key="optionsCode" ref="upSelectduoxuan"
                                                                :multiple="true" :popper-append-to-body="false"
                                                                v-model="item.selectedCodes"
                                                                :placeholder="item.leadsQuestions.defaultTips">
                                                                <el-option v-for="(ite) in item.leadsOptions" 
                                                                    :key="ite.optionsCode" :label="ite.optionsContent"
                                                                    :value="ite">
                                                                </el-option>
                                                            </el-select>
                                                        </div>

                                                        <div v-if="item.leadsQuestions.type == 9">
                                                            <el-select filterable clearable :loading="loading"
                                                                style="width: 100%;" :popper-append-to-body="false"
                                                                ref="upSelectduoxuanSearch" value-key="aaa_id"
                                                                v-model="item.selectedCodes" remote :multiple="true"
                                                                :remote-method="debouncedRemoteMethodCompany3"
                                                                :placeholder="item.leadsQuestions.defaultTips">
                                                                <template slot="prefix">
                                                                    <i class="el-input__icon el-icon-search"></i>
                                                                </template>
                                                                <el-option v-for="(ite) in item.leadsOptions"
                                                                    :key="ite.aaa_id" :label="ite.company_name_en"
                                                                    :value="ite">
                                                                    <div class="flex_center_start_box Search_Company">
                                                                        <img class="Country_img" :src="ite.flag" /><span
                                                                            class="Country_name">{{ ite.company_name_en
                                                                            }}</span></div>
                                                                </el-option>
                                                            </el-select>
                                                        </div>
                                                        <div v-if="item.leadsQuestions.type == 5">

                                                            <div style="display: flex;margin-bottom: 10px;"  class="reaio-no">
                                                                
                                                                <el-radio border v-model="item.selectedOptions" 
                                                                    label="Yes">Yes</el-radio>
                                                                <el-radio border style="margin-left: 1.42857143rem;" v-model="item.selectedOptions"
                                                                    label="No">No</el-radio>
                                                            </div>
                                                            <div>
                                                                <el-input id="ceb3e3" v-model="item.selectedCodes"
                                                                    v-if="item.selectedOptions == 'Yes'"
                                                                    :placeholder="item.leadsQuestions.defaultTips">
                                                                </el-input>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </el-collapse-item>

                                        </el-collapse>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <div  class="postion_bottom">
                        <div class="  flex_center" v-if="NewShowIndex == 0">


                        <button
                            :disabled="QuestionPageList.slice(0, (QuestionPageList.filter(item => item.leadsQuestions?.pageNo <= 1)).length).filter(item => (item.selectedCodes == null || item.selectedCodes.length == 0)).length > 0"
                            class=" btn_exportyellow riskButton" @click="NewShowIndex = NewShowIndex + 1">
                            <span
                                v-if="QuestionPageList.slice(0, (QuestionPageList.filter(item => item.leadsQuestions?.pageNo <= 1)).length).filter(item => (item.selectedCodes == null || item.selectedCodes.length == 0)).length > 0">Select
                                all That Apply</span><span v-else>OK</span>
                        </button>
                    </div>
                    <div class="  flex_center" v-if="NewShowIndex == 1">


                        <button
                            :disabled="QuestionPageList.slice(0, (QuestionPageList.filter(item => item.leadsQuestions?.pageNo <= 2)).length).filter(item => (item.selectedCodes == null || item.selectedCodes.length == 0)).length > 0"
                            class=" btn_exportyellow riskButton" @click="NewShowIndex = NewShowIndex + 1">
                            <span
                                v-if="QuestionPageList.slice(0, (QuestionPageList.filter(item => item.leadsQuestions?.pageNo <= 2)).length).filter(item => (item.selectedCodes == null || item.selectedCodes.length == 0)).length > 0">Select
                                all That Apply</span><span v-else>OK</span>
                        </button>
                    </div>
                    <div class="  flex_center" v-if="NewShowIndex == 2">


                        <button
                            :disabled="QuestionPageList.slice(0, (QuestionPageList.filter(item => item.leadsQuestions?.pageNo <= 3)).length).filter(item => (item.selectedCodes == null || item.selectedCodes.length == 0)).length > 0" @click="NewShowIndex = NewShowIndex + 1"
                            class=" btn_exportyellow riskButton">
                            <span
                                v-if="QuestionPageList.slice(0, (QuestionPageList.filter(item => item.leadsQuestions?.pageNo <= 3)).length).filter(item => (item.selectedCodes == null || item.selectedCodes.length == 0)).length > 0" >Select
                                all That Apply</span><span v-else >OK</span>
                        </button>
                    </div>
                    <div class="flex_center" v-if="NewShowIndex == 3">

                        <button class=" btn_exportyellow riskButton"   style="margin-right: 20px;" :disabled="QuestionPageList.slice(0, (QuestionPageList.filter(item=>item.leadsQuestions?.required==1)).length).filter(item => (item.selectedCodes == null||item.selectedCodes.length==0)).length > 0"  @click="Savemyanswers">
                    Save My Answer
                </button>
                            <!-- <button class=" btn_exportyellow riskButton"
                                style="background-color: #E7E5FF;color:#8E86DD;margin-right: 20px;"
                                @click="questionWentiDialog = false">
                                Cancel
                            </button> -->
                            <button
                                :disabled="QuestionPageList.slice(0, (QuestionPageList.filter(item => item.leadsQuestions?.required == 1)).length).filter(item => (item.selectedCodes == null || item.selectedCodes.length == 0)).length > 0"
                                class=" btn_exportyellow riskButton" @click="ShowResult(false)">
                                Show Result
                            </button>
                    </div>
                </div>
                </div>
                <div class="Close-Icon"  @click="CanclogQuetion">
                   <svg t="1754987193340" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11027" id="mx_n_1754987193341" width="24" height="24"><path d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z" fill="#1A2332" p-id="11028"></path></svg>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="questionDialog" center :close-on-click-modal="true" @close="closeDialog"
            custom-class="dialog_normal_question" :append-to-body="true">
            <div>
                <div class="detail_cont">
                    <h3>Your search criteria for customer acquisition</h3>
                    <div class="question-detail_cont">
                        <ul>
                            <li class="question-detail_cont-list" v-for="(item, index) in quesitonList" :key="index">
                                <p>{{ item.label }}</p>
                                <h3>{{ item.value }}</h3>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
            <div class=" question_bottom">

                <button class=" btn_exportyellow riskButton" @click="Savemyanswers">
                    Save my answers
                </button>
                <div>
                    <button class=" btn_exportyellow riskButton"
                        style="background-color: #E7E5FF;color:#8E86DD;margin-right: 5px;" @click="closeDialog">
                        Cancel
                    </button> <button class=" btn_exportyellow riskButton" @click="ShowResult(false)">
                        Show result
                    </button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="SaveDialog" center :close-on-click-modal="true" @close="closeSaveDialog"
            custom-class="dialog_normal_question" :append-to-body="true">
            <div>
                <div class="detail_cont">
                    <h3 v-if="$parent.isNewQuestion" class="dialog_normal_question-head">Do you like to save your
                        current
                        selections of search criteria?</h3>

                    <h3 v-else class="dialog_normal_question-head">Save As</h3>
                    <div class="SaveDialog_input">
                        <el-input id="ceb3e3" v-model="templateName" placeholder="Please type your file name">
                        </el-input>
                    </div>

                </div>
            </div>
            <div class="  " style=" display: flex ;justify-content: center;">
                <div>
                    <button class=" btn_exportyellow riskButton"
                        style="background-color: #E7E5FF;color:#8E86DD;margin-right: 20px;min-width: 15rem !important" @click="closeSaveDialog">
                        {{ $t('MyAccount.Cancel') }}
                    </button>
                    <button v-if="$parent.isNewQuestion"  class=" btn_exportyellow riskButton"
                        style="margin-right: 20px;min-width: 15rem !important" @click="Nosave()">
                        No Save
                    </button>

                    <button :disabled="templateName.length == 0"  style="min-width: 15rem !important"  class=" btn_exportyellow riskButton"
                        @click="SaveInputName()">
                       {{ $t('MyAccount.Save') }}
                    </button>
                </div>
            </div>
        </el-dialog>
        <SearchLeads v-if="SearchLeadsSuo&&!questionWentiDialog" :suoClose="SearchLeadsSuo" @closeCloseDialog="clossuoDialog($event)"></SearchLeads>
    </div>

</template>
<script>
import _ from 'lodash';
import { mixins1 } from "@/mixins/index";
import SearchLeads from "../SearchLeads.vue";
import { searchCompany, } from "@/api/searchApi.js";
import {

    saveLeadsPostFilter

} from "@/api/companyApi.js";
import { saveLeadsAnswers, getLeadsQuestions, getLeadsProductFilterList, getIndustryCodeFilterList, updateLeadsAnswersHead } from "@/api/userApi";
import { jwtDecode } from 'jwt-decode';
import { json } from 'd3';

export default {
    mixins: [mixins1],
    components: {
        SearchLeads,
    },

    name: "",
    props: {
        CompanyQuestionShow: {
            type: Boolean
        }
    },

    watch: {
        '$store.state.app.leadesTags': {
            handler(newVal, oldVal) {
                this.SavedAnswersList = newVal
                // 在这里处理columns属性的变化

            },
            deep: true, // 深度监听，可以监听对象内部属性的变化
            immediate: true, // 立即执行一次handler函数，即使columns没有变化
        },

        CompanyQuestionShow: {
            handler(newVal, oldVal) {

                if (newVal) {
                    // console.log(`questionWentiDialog`,questionWentiDialog );
                    // this.$parent.token
                    if (true) {
                        //    this.questionWentiDialog=newVal

                        this.getListsaveLeadsAnswers()
                        this.showInptIndustry = true
                        this.NewShowIndex = 0
                this.setToolsAciveFalse()
                        
                    }
                }

                // 在这里处理Sort属性的变化
            },
            deep: true, // 深度监听，可以监听对象内部属性的变化
            immediate: true, // 立即执行一次handler函数，即使columns没有变化
        },

    },
    created() {
        
    },
    mounted() {
        this.setToolsAciveFalse()
        this.$store.dispatch("app/setThemColor", "#8E86DD");
        this.$store.dispatch("app/setSearchType", "risk");


    },
    data() {
        return {
            ProductIndustryList: [],
            cascInptIndustry: "",
            showInptIndustry: true,
            trigger: "manual",
            SaveDialog: false,
            questionWentiDialog: false,
            statesCountryarr: '',
            questionDialog: false,
            objectTypeValue: [],
            activeNames: ['0'],
            templateName: '',
            QuestionPageList: [],
            QuestionPageListON: [],
            arrSearch: [],
            objectTypeoptions: [],
            statesCountry: [],
            SearchLeadsSuo: true,
            quesitonList: [],
            CompanyCountryoptions: [],
            isCpc: true,
            Companyoptions: [],
            Companyvalue: ['APPLE', 'COLFAX CORPORATION'],
            competitorsCompanyvalue: ['APPLE', 'COLFAX CORPORATION', 'HUAWEI'],
            CompanyCountryvalue: ['China'],
            list: [],
            loading: true,
            QuestionLoding: false,
            states: [],
            currentIndex: 0,
            index: -1,
            percentage: 34,
            carouselItems: ["", "", "", "", "", ""],
            roleQuestion: [],
            targetingradio: "1",
            SavedAnswerIndexActive: undefined,
            checkList: [],
            SavedAnswersList: [],
            cascaderProps: {
                // 这里设置最后一层可以多选
                multiple: false,
                checkStrictly: false, // 允许选择不严格
                emitPath: false, // 不发出路径
                label: 'optionsContent',  // 显示的标签
                value: 'id',     // 选中的值
                children: 'list',
                // 其他属性可以根据需要添加
            },
            cascaderPropsProduct: {
                multiple: false,
                checkStrictly: false, // 允许选择不严格
                emitPath: false, // 不发出路径
                label: 'optionsContent',  // 显示的标签
                value: 'id',     // 选中的值
                children: 'list',
            },
            urposeValue: "",
            qualificationsValue: '',
            audienceValue: '',
            lengthValue: '',
            enterpriseValue: '',
            creditValue: '',
            selectValue: '',
            sizeValue: '',
            resquestion: {},
            keyword: '',
            NewShowIndex: 0

        };
    },

    methods: {
        CanclogQuetion(){
            this.questionWentiDialog=false
            this.SearchLeadsSuo=true
            this.NewShowIndex=0
            this.getListsaveLeadsAnswers()
        },
          setToolsAciveFalse() {
            this.$store.dispatch("app/setTools", {
                name: "Optimize",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "filter",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "menu",
                key: "isActive",
                value: true,
            });
            this.$store.dispatch("app/setTools", {
                name: "sort",
                key: "isActive",
                value: false && this.$parent.token,
            });
            this.$store.dispatch("app/setTools", {
                name: "select",
                key: "isActive",
                value: false && this.$parent.token,
            });
            this.$store.dispatch("app/setTools", {
                name: "edit",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "collect",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "saved",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "compare",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "export",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "update",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "download",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "reportError",
                key: "isActive",
                value: false,
            });
            this.$store.dispatch("app/setTools", {
                name: "share",
                key: "isActive",
                value: false,
            });

            //   this.$store.dispatch("app/setTools", "filter",'isActive',false);
        },
        ActiceNewIndex(index) {
            
                let indexTrue =!(this.QuestionPageList.slice(0, (this.QuestionPageList.filter(item => item.leadsQuestions?.pageNo <= 1)).length).filter(item => (item.selectedCodes == null || item.selectedCodes.length == 0)).length > 0)
           
                if(indexTrue &&index==1){
            this.NewShowIndex = index
           
            }
                let indexTrueTwo =!(this.QuestionPageList.slice(0, (this.QuestionPageList.filter(item => item.leadsQuestions?.pageNo <= 2)).length).filter(item => (item.selectedCodes == null || item.selectedCodes.length == 0)).length > 0)
          
               if(indexTrueTwo &&index==2){
            this.NewShowIndex = index
           
            }
               let indexTrueTree =!(this.QuestionPageList.slice(0, (this.QuestionPageList.filter(item => item.leadsQuestions?.pageNo <= 3)).length).filter(item => (item.selectedCodes == null || item.selectedCodes.length == 0)).length > 0)
          
               if(indexTrueTree &&index==3){
            this.NewShowIndex = index
           
            }
                if(this.NewShowIndex> index){
                  this.NewShowIndex = index
            }
            

        },
        handleactiveNamesChange(val) {
            if (this.$parent.PCMoudele[3].hasPrivilege) {
                this.activeNames = val
            } else {
                this.activeNames = ['0']
                this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
            }
            //
            // 
        },
        highlightKeyword(text) {

            if (!this.keyword) {
                return text
            }
            const regex = new RegExp(this.keyword, 'gi')
            return text.replace(regex, match => `<span class="highlight">${match}</span>`)
        },
        clossuoDialog(value) {
            this.questionWentiDialog = true
            this.SearchLeadsSuo = value;
        },
        cascaderflase() {
            // this.$refs.cascader[0].dropDownVisible=false
        },
        clickOutSide() {

            // this.$refs.cascader[0].dropDownVisible=false

            //  
            if (this.$refs.upSelectwo) {
                this.$refs.upSelectwo.forEach(item => {
                    item.visible = false
                })
            } if (this.$refs.upSelectduoxuanSearch) {
                this.$refs.upSelectduoxuanSearch.forEach(item => {
                    item.visible = false
                })
            }
            if (this.$refs.upSelect) {
                this.$refs.upSelect[0].visible = false

            }
            if (this.$refs.upSelectduoxuan) {
                this.$refs.upSelectduoxuan[0].visible = false

            }

        },
        clickOutSideTwo(index) {

        },
        Finish() {
            this.quesitonList = []
            this.questionDialog = true
            this.QuestionPageList.forEach((item, index) => {
                if (item.selectedCodes != null) {
                    if (Array.isArray(item.selectedCodes)) {
                        if (item.selectedCodes.length > 0) {
                            if (item.leadsQuestions.type == 9) {
                                this.quesitonList.push({
                                    value: (item.selectedCodes.map(item => { return item.optionsContent })).join(',')
                                    ,
                                    label: item.leadsQuestions.questionContent,
                                })

                            } else {
                                this.quesitonList.push({
                                    value: (item.leadsQuestions.type == 7 || item.leadsQuestions.type == 5) ? item.selectedCodes : (item.selectedCodes.map(item => { return item.optionsContent })).join(',')
                                    ,
                                    label: item.leadsQuestions.questionContent,
                                })
                            }

                        }
                    } else {


                        this.quesitonList.push({
                            value: (item.leadsQuestions.type == 7 || item.leadsQuestions.type == 5) ? item.selectedCodes : item.selectedCodes.optionsContent,
                            label: item.leadsQuestions.questionContent,
                        })
                    }

                }

                // else {

                //     if (item.selectedCodes != null) {
                //         this.quesitonList.push({
                //             value: item.selectedCodes[0].optionsContent,
                //             label: item.selectedCodes.questionContent,
                //         })
                //     }
                // }
            })
        },
        leadsQuestionschange(value) {
          
            if (value.optionsType == 1) {
                this.QuestionPageList.map((item, index) => {
                    if (index > 0) {
                        item.selectedCodes = null
                        item.selectedOptions = null
                    }
                })

            }

            let arrQusetion = this.QuestionPageList.map(item => {
                return { ...item, selectedOptions: item.selectedCodes == null ? null : JSON.stringify(item.selectedCodes) };
            });
            getLeadsQuestions({
                leadsAnswersHead: {
                    "id": null,
                    "userId": null,
                    "title": null,
                    "creatTime": null,
                    "updateTime": null
                },
                leadsQuestionsVOList: arrQusetion

            }).then(res => {
                this.QuestionPageList = []

                if (res.code == 200) {

                    this.QuestionPageList = res.data.leadsQuestionsVOList

                    this.QuestionPageList.map((item, index) => {

                        item.selectedCodes = item.selectedCodes == null ? JSON.parse(item.selectedCodes) : item.selectedCodes
                        item.showCode = item.selectedCodes == null ? null : item.selectedCodes.id

                    })


                }
                console.log(this.NewShowIndex);
                
                if(  this.QuestionPageList.length>3&&this.$route.query.aaa_id){

                    let index = this.QuestionPageList.findIndex(item => item.leadsQuestions.type == 9 && item.leadsQuestions.code == 6);
                   console.log(index);
                    let seachCompanyList=[
                      { 
                        optionsCode: this.$route.query.aaa_id,
                        optionsContent: this.$route.query.name_en,
                        flag: this.$route.query.country_code,
                        aaa_id: this.$route.query.aaa_id
                       }
                   
                    ]
                        let countryImg = this.getCountryImgUrl(this.$route.query.country_code);
                            let flag = require("../../../../../static" + countryImg);
                            seachCompanyList[0].flag = flag;
                   
                    this.QuestionPageList[index].leadsOptions = seachCompanyList
                    // this.QuestionPageList[index].selectedCodes=seachCompanyList[0]
                    // console.log('  this.QuestionPageList[index].leadsOptions',seachCompanyList[0]);
                    // console.log(  this.QuestionPageList[index].selectedCodes);
                    
                    
                    // this.QuestionPageList[index].selectedCodes=seachCompanyList[0]
                }

            })

        },
        cleanEmptyLists(options) {
            return options
                .map(option => {
                    // 递归清理子选项
                    const cleanedChildren = this.cleanEmptyLists(option.list);
                    // 只保留非空的子选项，若为空则置为 null
                    return {
                        ...option,
                        list: cleanedChildren.length > 0 ? cleanedChildren : null // 修改这里
                    };
                })
            // .filter(option => option.list !== null); // 只保留 list 不为 null 的选项
        },
        getListsaveLeadsAnswers() {
            getLeadsQuestions({

            }).then(res => {
                if (res.code == 200) {
                    this.resquestion = res
                    this.QuestionPageList = res.data.leadsQuestionsVOList
                    this.QuestionPageListON = res.data.leadsQuestionsVOList
                    this.QuestionPageList.map(item => {

                        item.showCode = null
                    })

                    // this.QuestionPageList[0].leadsOptions.forEach(item=>{
                    //    if( item.list.length>0){
                    //     item.list.forEach(ite=>{
                    //         ite.list=null
                    //     })
                    //    }
                    // })
                }

            })

        },
        // ShowResult自己展示
        ShowResult() {
            if(this.$parent.token){
            this.$parent.isNewQuestion = true
            this.questionWentiDialog = false
            this.$parent.CompanyQuestionShow = false
            this.questionDialog = false
            this.$parent.setToolsAcive()
            this.$emit('getPantentList', this.QuestionPageList)
            }else{
                 this.$parent.$parent.$parent.loginDialog=true
            }
          

            // this.SaveDialog = false
        },

        //    输入保存问题
        SaveInputName() {


            if (this.$parent.SaveAnswer && this.$store.state.app.SeachLabels != '') {
                //    console.log(`this.$parent.ComanyFilterList`, this.$parent.ComanyFilterList);
                let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
                let arrFileter = this.$parent.ComanyFilterList.map((item, index) => {
                    if (Array.isArray(item.selectedCodes) && item.selectedCodes.length > 0) {
                        item.selectedOptions = item.leadsOptions.filter((ite) => { return ite.optionsCode == item.selectedCodes[0] })

                    }
                    return { ...item, }
                });
                // console.log(`arrFileter`, arrFileter);
                arrFileter.map(item => {
                    item.selectedOptions = (item.selectedOptions == null || item.selectedCodes.length == 0) ? null : JSON.stringify(item.selectedOptions[0])
                })

                saveLeadsPostFilter({

                    leadsAnswersHead: {
                        id: this.$store.state.app.SeachLabels,
                        userId: userinfo.id,
                        title: this.templateName,
                        creatTime: null,
                        updateTime: null,
                    },
                    leadsQuestionsVOList: arrFileter
                }).then(res => {
                })
                updateLeadsAnswersHead({
                    leadsAnswersHead: {
                        id: this.$store.state.app.SeachLabels,
                        userId: userinfo.id,
                        title: this.templateName,
                        creatTime: null,
                        updateTime: null,

                    },
                }).then(res => {
                    if (res.code == 200) {
                        this.SaveDialog = false
                        this.$parent.$parent.$parent.getCommonPrivilegeModule()
                        this.$message({
                            message: res.msg,
                            center: true,
                            type: "success",
                        });
                    } else {
                        this.$message({
                            message: res.msg,
                            center: true,
                            type: "error",
                        });
                    }
                })

            } else {
                let arrQusetion = this.QuestionPageList.map((item, index) => {
                    if (Array.isArray(item.selectedCodes)) {
                        if (item.selectedCodes.length > 0) {
                            item.selectedCodes.map(ite => {
                                ite.list = null
                            })
                        } else {
                            item.selectedCodes = null
                        }

                    }
                    return { ...item, selectedOptions: (item.selectedCodes == null) ? null : JSON.stringify(item.selectedCodes), selectedCodes: item.selectedCodes };
                });


                let userinfo = JSON.parse(localStorage.getItem('userInfo')).userInfo;
                saveLeadsAnswers({
                    leadsAnswersHead: {
                        id: null,
                        userId: userinfo.id,
                        title: this.templateName,
                        creatTime: null,
                        updateTime: null,

                    },
                    leadsQuestionsVOList: arrQusetion
                }).then(res => {
                    if (res.code == 200) {
                        this.$parent.$parent.$parent.getCommonPrivilegeModule()

                        this.$store.dispatch("app/SetSeachLabels", res.data.leadsAnswersHead.id);
                        this.$store.dispatch("app/SetSeachLabelsCodeName", res.data.leadsAnswersHead.title);
                        this.questionWentiDialog = false
                        this.$parent.CompanyQuestionShow = false
                        this.questionDialog = false
                        this.SaveDialog = false
                        this.$parent.isNewQuestion = false

                        // this.$store.commit("setRefreshKey", new Date().getTime());
                    } else {
                        this.$parent.isNewQuestion = true
                        this.$message({
                            message: res.msg,
                            center: true,
                            type: "error",
                        });
                    }
                })



                // this.ShowResult()

            }



        },
        // 保存问题弹框
        Savemyanswers() {
            if(this.$parent.token){
      if (this.$parent.PCMoudele[5].hasPrivilege) {
                this.$parent.isNewQuestion = false
                this.SaveDialog = true
            } else {
                this.$bus.$emit('show-permission-dialog', '您没有权限访问该功能！')
            }
            
            }else{
                 this.$parent.$parent.$parent.loginDialog=true
            }
      
            // if(this.$parent.PCMoudele){

            // }
            // 
        },
        // 关闭保存弹框
        closeSaveDialog() {
            this.SaveDialog = false
            this.$parent.RiskLoding = false

        },
        Nosave() {
            this.SaveDialog = false
            this.$parent.isNewQuestion = false
        },
        //关闭弹框
        closeDialog() {
            this.questionDialog = false
        },
        goToNextSlide1() {
            this.percentage = this.percentage - 33;
            this.$refs.carousel.prev();
        },
        // 模糊 搜索
        competitorsremoteMethod(query) {
            if (query !== "") {

                this.loading = false;
                this.Companyoptions = this.states.filter((item) => {
                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
            } else {
                this.Companyoptions = [];
            }
        },

        // 公司名称模糊搜索
        debouncedRemoteMethodCompany: _.debounce(function (query) {
            this.loading = false
            this.remoteMethodSeachCompany(query, 6);
        }, 1000), // 300毫秒延迟
        debouncedRemoteMethodCompany3: _.debounce(function (query) {
            this.loading = false
            this.remoteMethodSeachCompany(query, 7);
        }, 1000), // 300毫秒延迟
        async remoteMethodSeachCompany(query, page) {

            if (query !== "") {
                this.loading = true;
                this.keyword = query

                let params = {
                    company_name: query,
                    page: 1,
                    pageSize: 100,

                };
                //    'company_name=' + this.searchName + '&company_country=' + this.searchCode + '&page=' + this.page.pageNo + '&pageSize=' + this.page.pageSize + '&province_en=' + this.province + '&city_en=' + this.city + '&isic_code=' + this.industryCheck + '&company_class_code=' + this.companyTypeCheck + '&searchType=' + this.keywords + '&scale_code=' + this.companySizeCheck + '&reg_status=' + this.companyStatusCheck + '&listing_status_code=' + this.listedCompanyCheck + '&years=' + this.timePeriodCheck
                let res = await searchCompany(params);

                let parentTable = [];
                if (res.code == 200) {

                  setTimeout(() => {
                    let list = (parentTable = res.data.rows);

                    //查找本地图片
                    list = list.map((item, index) => {
                        let countryImg = this.getCountryImgUrl(item.company_country);
                        if (countryImg) {
                            let flag = require("../../../../../static" + countryImg);
                            parentTable[index].flag = flag;

                        }
                    });
                    let index = this.QuestionPageList.findIndex(item => item.leadsQuestions.type == 9 && item.leadsQuestions.code == page);
                    let seachCompanyList = []
                    seachCompanyList = parentTable.map(item => {
                        return { optionsCode: item.aaa_id, optionsContent: item.company_name_en ? item.company_name_en : item.company_name, flag: item.flag, aaa_id: item.aaa_id };
                    });
                    this.QuestionPageList[index].leadsOptions = seachCompanyList

                    this.loading = false;
                },10)

                } else {
                    // this.addPopIndex2=true
                    if (res.code == "1002") {
                        this.$message({
                            message: res.msg,
                            center: true,
                            type: "error",
                        });
                    } else {
                        this.loading = false;
                        // this.parentTable = [];

                    }
                }
            } else {
                // this.loading = false;
                this.Companyoptions = [];
            }
        },
        debouncedRemoteMethodfocus(query) {
            // console.log(`query`, query);
            // this.$refs.upSelectProductSearch[0].visible=false

        },
        debouncedRemoteMethod: _.debounce(function (query) {
            this.remoteMethod(query, 3);
        }, 300), // 300毫秒延迟
        debouncedRemoteMethod3: _.debounce(function (query) {
            this.remoteMethod(query, 12);
        }, 300),
        debouncedRemoteMethodgetProductList: _.debounce(function (query) {
            this.getProductList(query);
        }, 800),
        // 模糊 搜索
        remoteMethod(query, page) {

            if (query !== "") {
                this.keyword = query
                this.loading = true;
                let industryCode = ["FI1001", "IF1001", "GM1001", "GM1003", "SC1001", "SC1003", "ID1001", "ID1003"]
                if (industryCode.includes(this.QuestionPageList[1].selectedCodes.optionsCode)) {
                    getIndustryCodeFilterList({
                        optionsContent: query
                    }).then(res => {
                        if (res.code == 200) {
                            setTimeout(() => {
                                this.loading = false;

                                let index = this.QuestionPageList.findIndex(item => item.leadsQuestions.type == 8);
                                this.QuestionPageList[index].leadsOptions = res.data
                            }, 10);

                        } else {
                            this.Companyoptions = []
                        }
                    })
                } else {
                    getLeadsProductFilterList({
                        // isicCode: this.QuestionPageList[0].selectedCodes.optionsCode,
                        productNameDesc: query,
                        pageSize: 50
                    }).then(res => {
                        if (res.code == 200) {
                            setTimeout(() => {
                                this.loading = false;

                                let index = this.QuestionPageList.findIndex(item => item.leadsQuestions.type == 8);
                                this.QuestionPageList[index].leadsOptions = res.data
                            }, 10);

                        } else {
                            this.Companyoptions = []
                        }

                    })
                }


            } else {
                // ;
            }
        },
        menuCheck(value) {
            if (value) {
                this.showInptIndustry = false;
                this.cascInptIndustry = "";
                this.QuestionPageList[2].leadsOptions.forEach((item) => {
                    item.list.forEach(ite => {
                        if (ite.id == value) {
                            this.QuestionPageList[2].selectedCodes = ite
                        }
                    })
                })

            } else {
                this.showInptIndustry = true;
            }

        },
        getProductList() {


            if (this.cascInptIndustry !== "") {
                this.keyword = this.cascInptIndustry
                this.loading = true;


                getLeadsProductFilterList({
                    // isicCode: this.QuestionPageList[0].selectedCodes.optionsCode,
                    productNameDesc: this.cascInptIndustry,
                    pageSize: 100
                }).then(res => {
                    if (res.code == 200) {
                        setTimeout(() => {
                            this.loading = false;

                            let index = this.QuestionPageList.findIndex(item => item.leadsQuestions.type == 8);
                            this.QuestionPageList[index].leadsOptions = res.data
                        }, 10);
                        this.$nextTick(() => {
                            this.$refs.IndustryProduct[0].dropDownVisible = true;
                        });

                    } else {
                        this.Companyoptions = []
                    }

                })
            } else {
                // ;
            }
        },
        // 模糊 搜索国家
        remoteMethodCountry(query) {
            if (query !== "") {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.CompanyCountryoptions = this.statesCountry.filter((item) => {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.CompanyCountryoptions = [];
            }
        },
        // 左侧如果有保存条件
        SavedAnswerIndex(item, index) {
            this.SavedAnswerIndexActive = index;
            this.currentIndex = 0;
            this.percentage = 34;
            this.$nextTick(() => {
                this.$refs.carousel.setActiveItem(0);
            })

            let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;

            getLeadsQuestions({
                leadsAnswersHead: {
                    id: item.id,
                    userId: userinfo.id,
                    title: null,
                    creatTime: null,
                    updateTime: null,
                },
            }).then((res) => {
                if (res.code == 200) {
                    this.QuestionPageList = res.data.leadsQuestionsVOList

                    this.QuestionPageList.map((item, index) => {
                        item.selectedCodes = JSON.parse(item.selectedOptions);
                        if (item.leadsQuestions.type == 9) {
                            item.leadsOptions = item.selectedCodes
                        }
                        if (index == 0) {

                            item.showCode = Number(item.selectedCodes.id);
                        }



                    })

                    // this.CompanyQuestionList = res.data.leadsQuestionsVOList.filter(
                    //     (item) => item.selectedOptions != null
                    // );
                    // this.CompanyQuestionList.map((item, index) => {
                    //     item.selectedCodes = JSON.parse(item.selectedOptions);
                    //     if (index == 0) {
                    //         item.showCode = Number(item.selectedCodes.id);
                    //     }
                    // });



                }
            });
        },
        handleChange(value) {

            let arr = null
            this.QuestionPageList[0].leadsOptions.forEach(item => {
                item.list.forEach(ite => {
                    if (ite.list != null) {
                        ite.list.forEach(it => {
                            if (it.id == value) {
                                arr = it

                            }
                        })

                    }

                })
            })
            this.QuestionPageList[0].selectedOptions = JSON.stringify(arr)
            this.QuestionPageList[0].selectedCodes = JSON.stringify(arr)
            let arrQusetion = this.QuestionPageList
            // this.QuestionPageList[1].selectedCodes = []


            getLeadsQuestions({
                leadsAnswersHead: {
                    "id": null,
                    "userId": null,
                    "title": null,
                    "creatTime": null,
                    "updateTime": null
                },
                leadsQuestionsVOList: arrQusetion

            }).then(res => {
                if (res.code == 200) {
                    this.QuestionPageList = res.data.leadsQuestionsVOList

                    this.QuestionPageList.map((item, index) => {

                        item.selectedCodes = JSON.parse(item.selectedCodes)
                        item.showCode = item.selectedCodes == null ? null : item.selectedCodes.id

                    })


                }

            })
        },
        handleChangetwo(value) {
            let index = this.QuestionPageList.findIndex(item => item.leadsQuestions.id == 11);
            let arr = null
            this.QuestionPageList[index].leadsOptions.forEach(item => {
                item.list.forEach(ite => {
                    if (ite.list != null) {
                        ite.list.forEach(it => {
                            if (it.id == value) {
                                arr = it

                            }
                        })

                    }

                })
            })
            this.QuestionPageList[index].selectedOptions = JSON.stringify(arr)
            this.QuestionPageList[index].selectedCodes = arr

        },
        handleCarouselChange(index) {
            this.currentIndex = index;
        },
        // 下一页
        goToNextSlide(index) {
            if (index == 0) {


                let arrQusetion = this.QuestionPageList.map(item => {
                    return { ...item, selectedOptions: item.selectedCodes == null ? null : JSON.stringify(item.selectedCodes) };
                });

                getLeadsQuestions({
                    leadsAnswersHead: {
                        "id": null,
                        "userId": null,
                        "title": null,
                        "creatTime": null,
                        "updateTime": null
                    },
                    leadsQuestionsVOList: arrQusetion

                }).then(res => {
                    if (res.code == 200) {
                        this.QuestionPageList = res.data.leadsQuestionsVOList

                        this.QuestionPageList.map((item, index) => {

                            if (item.leadsQuestions.id == 5 && item.selectedOptions == null) {
                                item.selectedCodes = []
                            }
                            if (item.leadsQuestions.type == 8 && item.selectedOptions != null) {
                                item.leadsOptions = [item.selectedCodes]
                            }
                            item.showCode = item.selectedCodes == null ? null : item.selectedCodes.id
                        })



                    }

                })
            }
            if (index === this.currentIndex) {
                this.percentage = this.percentage + 33;
                this.$refs.carousel.next();
            }
        },
    },
    computed: {},
};
</script>
<style scoped>
.leads-head {
    height: 18.285714285714285rem;
    width: 100%;
    background: #8E86DD;
    padding: 1.8571428571428572rem 1.4285714285714286rem;
}

.leads-head-title {
    margin-left: 0.7142857142857143rem;
    font-family: DMSans, DMSans;
    font-weight: 400;
    font-size: 2.2857142857142856rem;
    color: #ffffff;
    height: 3rem;
    line-height: 3.2857142857142856rem;
}

.leads-head-titleTwo {
    margin-left: 0.7142857142857143rem;
    height: 2.142857142857143rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 1.42857142857142858rem;
    color: #ffffff;
    line-height: 2.142857142857143rem;
    margin-top: 0.7142857142857143rem;
}

.leads-content {
    position: relative;
    /* top: -8.428571428571429rem; */
    z-index: 990;
    /* padding: 1.4285714285714286rem; */
    /* height: 100%; */
    background: #F5F5F5;
    border-radius: 6px;
}

.leads-flex {
    display: flex;
    height: 100%;
    /* overflow-y:scroll ; */
}

.leads-content-left {
    width: 48.57142857142857rem;
    max-height: 55.57142857142857rem;
    margin-right: 0.7142857142857143rem;
    background: #ffffff;
    box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
    border-radius: 0.2857142857142857rem;
    text-align: center;
    padding-top: 2.857142857142857rem;
    position: relative;
}

.leads-content-right {
    flex: 1;
    /* overflow: hidden; */
    /* height: 225%; */
    background: #F5F5F5;
    border-radius: 6px;
    text-align: center;
    /* overflow-y: auto; */
    padding: 1.4285714285714286rem
}

.leads-content-left-text {
    font-family: DMSans, DMSans;
    font-weight: 400;
    font-size: 1.42857142857142858rem;
    color: #666666;
    line-height: 1.8571428571428572rem;
    text-align: left;
    width: 56%;
    margin: 2.142857142857143rem auto;
}

.leads-content-left-jiantou {
    position: absolute;
    bottom: 3.857142857142857rem;
    right: 4.857142857142857rem;
}

.leads-content-right-content {
    /* width: 58%; */
    margin: 0 auto;
    text-align: center;
    height: 100%;
}

.question-step-question {
    font-size: 1.7142857rem !important;
    color: #1a2332;
    min-height: 1.85714286rem;
    line-height: 2.714286rem;
    margin-bottom: 10px;
    display: flex;
    font-family: 'DMSans Bold';
    text-align: left;
    word-break: keep-all;

}

/* .question-step-question  /deep/ .el-input__icon {
    width: 1.5rem;

} */
.question-step-con {
    margin-bottom: 1.42867143rem;
}

.bitian {
    color: #f56b6b;
    font-size: 1.7142857142857142rem;
    margin-right: 0.7142857142857143rem;
}

.btn_exportyellow {
    min-width: 12.857142857142858rem;
    height: 2.857142857142857rem;
    background: #8E86DD;
    border-radius: 0.7142857142857143rem;
    padding: 0.5rem;
    font-size: 1.42857142857142858rem;
    color: #fff;
    /* line-height: 2.857142857142857rem; */
}

.question_bottom .btn_exportyellow {

    font-size: 1.1428571428571428rem;
    color: #fff;
}

.leads-content-right /deep/ .el-cascader {
    width: 100%;
}

.leads-content-right /deep/ .el-cascader-node__label {
    font-size: 1.2857142857142858rem;
    color: #1a2332;
}

.leads-content-right /deep/ .el-carousel__container {
    height: 100%;
}

.OptionalQuestions {
    font-weight: 400;
    font-size: 1.2857142857142858rem;
    color: #1290c9;
    height: 1.5714285714285714rem;
    margin-bottom: 1.4285714285714286rem;
}

.leads-content-right /deep/ .el-progress__text {
    display: none;
}

.progress {
    width: 34.285714285714285rem;
    text-align: center;
    margin: auto;

    margin-bottom: 3.5714285714285716rem;
}

.progressnum {
    height: 1.4285714285714286rem;
    font-size: 1.0714285714285714rem;
    color: #999999;
    margin-bottom: 1.1428571428571428rem;
}

.leads-content-right /deep/ .el-collapse-item__header {
    height: auto;
    line-height: normal;
    border: none !important;
    width: 14.285714285714286rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2857142857142rem;
    color: #8E86DD !important;
    background-color: #f5f5f5;
    margin-bottom: 1.42867143rem;

}
.leads-content-right /deep/ .el-collapse-hade:hover {
    text-decoration:underline;
}

.leads-content-right /deep/ .el-collapse {
    border: none;
}

.leads-content-right /deep/.el-carousel--horizontal {
    height: 100%;
}

.leads-content-right /deep/ .el-collapse-item__arrow {
    /* margin: -1.0714285714285714rem 0.5714285714285714rem 0 auto; */
    color: #8E86DD;
}

.leads-content-right /deep/ .el-radio.is-bordered {
    background: #ffffff;
    border-radius: 0.7142857142857143rem !important;
    border: 0.07142857142857142rem solid #cccccc;
}
.leads-content-right /deep/  .el-select-dropdown__list {
  min-height:26rem !important;
}

.leads-content-right /deep/.el-radio.is-bordered {
    width: 49%;
    /* height: 4rem; */
      height: 4.2857143rem !important;
    justify-content: flex-start;
    margin-right: 0rem !important;
    padding: 0rem;
    padding-left: 1.4285714285714286rem;
}

.leads-content-right /deep/ .el-radio.is-bordered.is-checked {
    border: 0.07142857142857142rem solid #8E86DD !important;
}

.leads-content-right /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #8E86DD;
}

.leads-content-right /deep/ .el-radio__input.is-checked .el-radio__inner::after {
    background: #8E86DD;
}

.leads-content-right /deep/ .el-radio__label {
    font-size: 1.2857142857142858rem;
    color: #1a2332;
    display: flex;
    align-items: center;
}

.leads-content-right /deep/ .el-collapse-item__content {
    padding-bottom: 0rem !important;
}

.leads-content-left-Savelist {
    margin-top: 0.7142857142857143rem;
    text-align: center;
}

.SavedAnswers-title {
    height: 2.857142857142857rem;
    font-family: DMSans, DMSans;
    font-weight: 400;
    font-size: 1.857142857143rem;
    color: #1a2332;
    text-align: center;
    margin-bottom: 2.142857142857143rem;
}

.SavedAnswers-list {
    height: 2.857142857142857rem;
    background: #f5f5f5;
    border-radius: 0.7142857142857143rem;
    padding-left: 2.142857142857143rem;
    width: 80%;
    margin: auto;
    line-height: 2.857142857142857rem;
    text-align: left;
    margin-bottom: 0.7142857142857143rem;
    font-size: 1.42857142857142858rem;
    color: #1a2332;
    cursor: pointer;
}

.SavedAnswers-listActive {
    position: relative;
    background: #8E86DD;
    color: #ffffff;
    cursor: pointer;
}

.right-icon {
    position: absolute;
    right: -1.0714285714285714rem;
    top: 32%;
}

.leads-content-right /deep/ .el-tag.el-tag--info .el-tag__close {
    color: #ffffff;
    background-color: #f56b6b;
}

.leads-content-right /deep/ .el-tag.el-tag--info {
    height: 2.857142857142857rem;
    background: #ffffff;
    border-radius: 1.6428571428571428rem;
    border: 0.07142857142857142rem solid #cccccc;
    font-size: 1.2857142857142858rem !important;
    color: #1a2332;
    margin-left: 1.42857143rem;
}

.-dropdown__item {
    font-size: 1.2857142857142858rem !important;
    color: #1a2332;
    /* line-height: 35px !important; */
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-bottom: 5px;
    white-space: normal;

}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    color: #8E86DD !important;
}

.question-detail_cont {
    width: 52.857142857142854rem;
    height: 42.42857142857143rem;
    background: #F5F5F5;
    border-radius: 0.42857142857142855rem;
    overflow-y: auto;
    padding: 1.4285714285714286rem;
    margin-top: 0.7142857142857143rem;
}

.question-detail_cont-list {
    margin-bottom: 2.142857142857143rem;
}

.question-detail_cont-list p {
    font-family: DMSans, DMSans;
    font-weight: 400;
    font-size: 1.42857142857142858rem;
    color: #666666;
    height: 1.7142857142857142rem;
    line-height: 1.7142857142857142rem;
}

.question-detail_cont-list h3 {
    margin-top: 0.7142857142857143rem;
    font-family: DMSans, DMSans;
    font-weight: 400;
    font-size: 1.42857142857142858rem;
    color: #1A2332;
    /* height: 1.7142857142857142rem;
    line-height: 1.7142857142857142rem; */
}

.question_bottom {
    padding-top: 1.4285714285714286rem;
    display: flex;
    justify-content: space-between;
}

.SaveDialog_input {
    margin: 2.142857142857143rem 0rem;
}

.SaveDialog_input /deep/ .el-input__inner {
    /* height: 3.5714285714285716rem; */
     height: 3.5714285714285716rem;
    background: #FFFFFF;
    border-radius: 0.5714285714285714rem;
    border: 0.07142857142857142rem solid #CCCCCC;
    font-size: 1.4285714285714286rem;
}

/deep/ .el-select-dropdown {
    left: 0px !important;
    width: 100%;

}

/deep/ .el-select-dropdown__item {
    height: auto !important;
    text-align: left;
    font-size: 1.42857142857142rem !important;
}

/deep/ .el-popper {
    z-index: 99 !important;
}

/deep/ .el-cascader .el-input.is-focus .el-input__inner {
    border-color: #CCCCCC !important;
}

/deep/ .highlight {
    color: #f56c6c;
    font-weight: bold;
}

.Country_img {
    height: 1.4rem;
    width: 2rem;
    margin-right: 0.8rem;
}

.Country_name {
    /* line-height: 1.6rem !important; */
    font-size: 1.42857143rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.Search_Company {
    margin-bottom: 0.5rem;
    height: 3rem;

}

.question-step-con /deep/ .el-select__tags {
    /* padding-left: 1.42857143rem; */
}


/deep/ .el-collapse-item__wrap {
    background-color: #f5f5f5 !important;
}

button:disabled {
    cursor: no-drop !important;
    background-color: #EEEEEE !important;
    color: #999999;
}

.el-saech-eye {
    position: absolute;
    right: 0.7142857142857143rem;
    top: 0px;
    color: #1A2332;
    font-size: 1.2857142857142rem;
}

/deep/ .el-select__input {
    margin-left: 10px;
    font-size: 1.2857142857142rem !important;
}

.ActiveCode {
    color: rgb(142, 134, 221)
}

.IndustryProvie {
    position: relative;
}

.IndustryProvie .cas_inpt {
    top: 0.514285rem;
    font-size: 1.4285714rem;
    width: 94%;
}

.newHuokequestion {
    width: 760px;
    background: #F5F5F5;
    border-radius: 20px;
    height: 95% !important;
    overflow-y: auto;
    position: relative;
      scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; 
}

.newHuokequestion .leads-content-right {
    height: 100% !important;
    width: 100%;

}
.newHuokequestion::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
.NewHuokeradio /deep/ .el-radio-group,
.NewHuokeradio,
.NewHuokeradio /deep/ .el-radio.is-bordered {
    width: 100% !important;
}

.NewHuokeradio /deep/ .el-radio.is-bordered+.el-radio.is-bordered,
.NewHuokeradio /deep/ .el-radio.is-bordered {
    margin-left: 0px !important;
    width: 100% !important;
    margin-bottom: 1rem;
}

.NewHuokeradio /deep/ .el-radio__input {
    display: none !important;
}

.ActiveRedio {
    border: 0.07142857142857142rem solid #8E86DD !important
}

.ActiveRedio /deep/ .el-radio__label {
    color: #1A2332 !important;
    font-family: 'DMSans Bold';

}

.newHouke-li {
    width: 60px;
    height: 6px;
    background: #DDDDDD;
    border-radius: 5px;
    margin-right: 0.8rem;
}

.newHouke-ul {
    display: flex;
    justify-content: center;
}

.newShowActive {
    background: #8E86DD;
    cursor: pointer;
}
.postion_bottom{
    position: absolute;
    left: 50%;
  transform: translateX(-50%);
  padding-bottom: 20px;
}
.reaio-no /deep/ .el-radio__input{
display: none;
}
.Close-Icon{
    position: absolute;
    right: 2.14285714rem;
    top: 2.14285714rem;
}
  /deep/ .el-collapse-item__content{
    min-height: 25rem;
}
</style>
